import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'app-icon-eco-material',
    templateUrl: './icon-eco-material.component.html'
})
export class IconEcoMaterialComponent implements OnInit {

    @Input() cssClass = 'icon--18';

    constructor() { }

    ngOnInit() {
    }

}
